import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assets/perks.css";
import "react-toastify/dist/ReactToastify.css";
import { StylesProvider } from "@material-ui/core/styles";

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider injectFirst>
      <App />
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
